import GardenDesignWithFourQuadrantHedgesImage from "../../images/tasks/garden-design-with-four quadrant-hedges.jpeg";
export const designCalendar = [
  {
    name: "Design",
    description:
      "Design is the creation of a plan or convention for the construction of an object, system or measurable human interaction.",
    learn: "https://www.youtube.com/watch?v=1Yb2x3b3n6o",
    frequency: "Bi-annual",
    bestMonths: ["January", "February", "June", "July", "August"],
    otherMonths: "all",
    image: GardenDesignWithFourQuadrantHedgesImage,
  },
];
